import { bl_fi_deposit_register_attachment_RowClass } from '../../dbschema/bl_fi_deposit_register_attachment.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositRegisterAttachmentContainerModel extends BaseContainerModel {
  bl_fi_deposit_register_hdr_attachment: bl_fi_deposit_register_attachment_RowClass = new bl_fi_deposit_register_attachment_RowClass();
}
